import modalMixin from './_modal';
import sendGaMixin from './_send_ga';
import commonMixin from './_common';
import flashMessageMixin from './_flash_messages';

/**
 * 拡張機能を実行するためのmixin
 */
export default {
    components: {
        'chrome-extension': {
            template: '#chrome_extension_component_template',
            data() {
                return {
                    // 拡張機能実行URL
                    extension_url: null,
                    // ga送信用アクション名
                    ga_action: null,
                };
            },
            components: {
                // ポップアップブロックされた時に表示するモーダル
                'popup-block-confirm': {
                    template: '#popup_block_confirm_template',
                    mixins: [modalMixin, sendGaMixin],
                    methods: {
                        // 案内モーダルを開く
                        show: function () {
                            this.sendGAPageView(location.pathname, 'modal_popup_block_confirm');
                            this.open();
                        },
                        // もう一度実行
                        retry: function () {
                            this.close();
                            this.$parent.startExtension();
                        }
                    }
                },
                // 拡張機能未インストールモーダル
                'install-extension-confirm': {
                    template: '#install_extension_confirm_template',
                    data() {
                        return {
                            // 拡張機能インストール済みフラグ
                            is_installed: false,
                        };
                    },
                    mixins: [modalMixin, sendGaMixin],
                    watch: {
                        // インストールチェックをし、インストール済みだったら閉じて再実行
                        is_installed: function (value) {
                            if (value && this.isOpen()) {
                                this.close();
                                this.$parent.startExtension();
                            }
                        }
                    },
                    created() {
                        // 拡張機能からinstalledのmessageが通知されたらフラグをtrueにする
                        window.addEventListener('message', (e) => {
                            if (typeof e.data.action === 'undefined') {
                                return;
                            }
                            switch (e.data.action) {
                                case 'installed':
                                    this.is_installed = true;
                                    console.log(e.data.action);
                                    break;
                                case 'not_installed':
                                    this.is_installed = false;
                                    console.log(e.data.action);
                                    break;
                            }
                        });
                    },
                    methods: {
                        // 拡張機能インストール判定ページを開く
                        openInstallChromeExtensions: function () {
                            window.open('/chrome_extensions', null, 'noopener=no');
                        },
                        // インストールチェック
                        isValid: function () {
                            if (!this.is_installed) {
                                this.sendGAPageView(location.pathname, 'modal_install_extension_confirm');
                                this.open();
                                return false;
                            }
                            return true;
                        }
                    }
                },
                // ヤフー未ログインモーダル
                'yahoo-login-confirm': {
                    template: '#yahoo_login_confirm_template',
                    mixins: [modalMixin, sendGaMixin],
                    async created() {
                        // ヤフーログイン画面からneed_loginのmessageが通知されたらモーダルを開く
                        window.addEventListener('message', async (e) => {
                            if (typeof e.data.action !== 'undefined' && e.data.action === 'need_login' && this.$parent.ga_action) {
                                this.sendGAPageView(location.pathname, 'modal_yahoo_login_confirm');
                                this.open();
                                console.log(e.data.action);
                            }
                        });
                    },
                    methods: {
                        // もう一度実行
                        retry: function () {
                            this.close();
                            this.$parent.startExtension();
                        }
                    }
                },
                // 非対応ブラウザモーダル
                'valid-browser-confirm': {
                    template: '#valid_browser_confirm_template',
                    mixins: [commonMixin, modalMixin, sendGaMixin],
                    methods: {
                        // 有効ブラウザチェック
                        isValid: function () {
                            if(!this.$_useChrome()) {
                                this.sendGAPageView(location.pathname, 'modal_valid_browser_confirm');
                                this.open();
                                return false;
                            }
                            return true;
                        }
                    }
                },
                // 拡張機能更新途中に発生したエラー時に表示するモーダル
                'extension-running-error': {
                    template: '#modal_extension_running_error_template',
                    data() {
                        return {
                            // エラー画面出しわけ default|authority
                            display: 'default',
                        };
                    },
                    mixins: [modalMixin, sendGaMixin],
                    computed: {
                        // スロットが未使用か
                        isEmptySlot: function () {
                            return isSlotEmpty(this.$slots);
                        },
                    },
                    async created() {
                        // ストクリから通知されたら
                        window.addEventListener('message', async (e) => {
                            if (typeof e.data.key === 'undefined') {
                                return;
                            }
                            switch (e.data.key){
                                case 'finish':
                                    this.$parent.emitFinishAction();
                                    break;
                                case 'error':
                                    if (typeof e.data.key !== 'undefined') {
                                        if (typeof e.data.display !== 'undefined') {
                                            this.display = e.data.display;
                                        }
                                        this.sendGAPageView(location.pathname, 'modal_extension_running_error');
                                        this.open();
                                    }
                                    break;
                            }
                        });
                    },
                    methods: {
                        // もう一度実行
                        retry: function () {
                            this.close();
                            this.$parent.startExtension();
                        }
                    }
                },
            },
            mixins: [
                commonMixin,
                flashMessageMixin,
            ],
            emits: ['finish-action'],
            methods: {
                // 拡張機能実行
                startExtension: async function(key = null, action = null, addParams = {}) {
                    // 実行時の初期設定
                    if (!await this.iniExtension(key, action, addParams)) {
                        return false;
                    }
                    // 非対応ブラウザチェック
                    if (!await this.$refs.valid_browser_confirm.isValid()) {
                        return false;
                    }
                    // 拡張機能インストールチェック
                    if (!await this.$refs.install_extension_confirm.isValid()) {
                        return false;
                    }
                    return await this.windowOpen(this.extension_url);
                },
                // 拡張機能発動URLを取得
                getExtensionUrl: async function (key, addParams = {}) {
                    this.$_loading();
                    let message = this.exception_error_message;
                    let url = null;
                    try {
                        const response = await axios.post('/storecreator_data/start_extension_url', {
                            key: key,
                            add_params: addParams,
                        });
                        url = response.data.url;
                        message = '';
                    } catch (e) {
                        message = this.getCatchMessage(e);
                    }
                    this.$_unloading();
                    if (message) {
                        this.appendFlashMessage({
                            level: 'alert-danger',
                            message: message,
                        }, this.$root);
                    }
                    return url;
                },
                // 別ウインドウで開く
                windowOpen: async function (url) {
                    if (window.open(url)) {
                        return true;
                    }
                    // popupブロック案内モーダルを開く
                    await this.$refs.popup_block_confirm.show();
                    return false;
                },
                // 実行時の初期設定
                iniExtension: async function (key, action, addParams) {
                    if (!action && !key) {
                        return true;
                    }
                    // ga送信用アクション名をセット
                    this.ga_action = (action) ? action : key + '_Alert';
                    // 拡張機能URLをセット
                    this.extension_url = await this.getExtensionUrl(key, addParams);
                    if (this.extension_url) {
                        return true;
                    }
                    return false;
                },

                // -------------------------
                // emit
                // -------------------------

                // 親コンポーネントへ完了通知
                emitFinishAction: function () {
                    this.$emit('finish-action');
                },

            }
        }
    },
    methods: {
        // 拡張機能実行
        startExtension: async function(key = null, action = null, addParams = {}) {
            return await this.$refs.chrome_extension.startExtension(key, action, addParams);
        }
    }
};
